module.exports = {
	"articleTitle1": "Campus events for Friday, Nov. 13 ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Kilwin's",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/seniors-fondly-recall-past-years-u",
	"articleSnippet1": "Nov 12, 2015 ... What: The Graduate Society of Women Engineers are leading a chocolate crawl \nwhere they will go to Kilwins, Cupcake Station, Frida Batidos, ...",
	"articleSnippet2": "Apr 14, 2003 ... LSA senior Hetal Desai said she remembers going to Kilwin's to eat ice cream. \nMany seniors had fond memories of eating out on campus.",
	"foodRecommendations": [
		{
			"text": "Their chocolate fudge is absolutely incredible.",
			"person": "Erik Forkin"
		},
		{
			"text": "I really enjoy the coolers, which are normally made of sorbet and sprite.",
			"person": "Erk Forkin"
		}
	],
	"articleTitle2": "Search form - ",
	"address": "107 E Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.27968,
		"lng": -83.748007
	},
	"totalMisc": 0,
	"categories": {
		"dessert": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/kilwins.json
// module id = 901
// module chunks = 0